import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'

import { WithStyles, Theme, withStyles, createStyles } from '@material-ui/core/styles'
import { ButtonBase, Grid, InputBase } from '@material-ui/core'

import inactiveSendIconUrl from '../../assets/send_inactive.svg'
import activeSendIconUrl from '../../assets/send_active.svg'

interface Props {
  text: string
  setText: (text: string) => void
  onSend: () => void
}

const styles = (theme: Theme) => createStyles({
  root: {
    padding: `${theme.spacing()}px ${theme.spacing() * 2}px`,
    borderTop: '1px solid #f0f0f0',
  },
  inputRoot: {
    padding: 0,
    flex: 1,
    '& > div': {
      display: 'flex',
    },
  },
  inputInput: {
    border: '1px solid #eee',
    backgroundColor: '#f5f5f5',
    padding: theme.spacing(),
  },
  sendIcon: {
    marginLeft: theme.spacing(),
  },
})

type InjectedProps = Props & WithStyles<typeof styles> & WrappedComponentProps

const GameChatInput: React.FC<InjectedProps> = ({ classes, intl, text, setText, onSend }) => (
  <Grid container alignItems="flex-end" className={classes.root}>
    <InputBase
      placeholder={intl.formatMessage({ id: 'chat_input_placeholder' })}
      value={text}
      onChange={(ev) => { setText(ev.target.value) }}
      margin="none"
      rowsMax="4"
      multiline
      classes={{
        root: classes.inputRoot,
        input: classes.inputInput,
      }}
    />
    <ButtonBase disabled={text.length === 0} onClick={onSend} className={classes.sendIcon}>
      <img alt="" src={text.length ? activeSendIconUrl : inactiveSendIconUrl} />
    </ButtonBase>
  </Grid>
)

export default withStyles(styles)(injectIntl(GameChatInput))
